import {createAsyncThunk, createSlice} from '@reduxjs/toolkit';

const initialState={
    sessionList:[],
    selectedSession:null,
    status:"idle",
    registerstatus:'failure',
    editstatus:'failure',
    deletestatus:'failure',
    error:''
}

export const fetchSessions=createAsyncThunk('sessions/fetchSessions', async ()=>{
    const username = 'admin'
    const password = 'survive9'
    const auth = btoa(`${username}:${password}`)
    const response = await fetch(
        '/baskets/apage/session/all',
        {
            headers: {
                'Authorization': `Basic ${auth}`,
                'Accept': 'application/json'
            }
        }
    )
    return response.json()
})

export const fetchSessionById = createAsyncThunk('sessions/fetchSessionById', async (sessionId)=>{
    const username = 'admin'
    const password = 'survive9'
    const auth = btoa(`${username}:${password}`)
    const response = await fetch(
        `/baskets/apage/session/${sessionId}`,
        {
            headers: {
                'Authorization': `Basic ${auth}`,
                'Accept': 'application/json'
            }
        }
    )
    return response.json()
})

export const fetchSessionByVisitorRelID = createAsyncThunk('sessions/fetchSessionByVisitorRelID', async (visitorId)=>{
    const username = 'admin'
    const password = 'survive9'
    const auth = btoa(`${username}:${password}`)
    const response = await fetch(
        `/baskets/apage/session/getSessionByVisitorId/${visitorId}`,
        {
            headers: {
                'Authorization': `Basic ${auth}`,
                'Accept': 'application/json'
            }
        }
    )
    return response.json()
})

export const createSession = createAsyncThunk('sessions/createSession', async (sessionData)=>{
    const username = 'admin'
    const password = 'survive9'
    const auth = btoa(`${username}:${password}`)
    const response = await fetch(
        '/baskets/apage/session/create',
        {
            method: 'POST',
            headers: {
                'Authorization': `Basic ${auth}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(sessionData)
        }
    )
    return response.json();
})

export const deleteSessionById = createAsyncThunk('sessions/deleteSessionById', async (sessionId)=> {
    const username = 'admin'
    const password = 'survive9'
    const auth = btoa(`${username}:${password}`)
    const response=await fetch(
        `/baskets/apage/session/delete/${sessionId}`,
        {
            method: 'DELETE',
            headers: {
                'Authorization': `Basic ${auth}`,
                'Accept': 'application/json'
            }
        }
    )
    return response.json();
})

const sessionSlice = createSlice({
    name: "sessions",
    initialState,
    reducers:{
        changeRegisterStatus:(state)=>{
            state.registerstatus='failure';
        },
        changeEditStatus:(state)=>{
            state.editstatus='failure';
        },
        changeDeleteStatus:(state)=>{
            state.deletestatus='failure';
        }
    },
    extraReducers:(builder)=> {
        builder
            .addCase(fetchSessions.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchSessions.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.sessionList = action.payload;
            })
            .addCase(fetchSessions.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.error.message;
            })
            .addCase(fetchSessionById.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchSessionById.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.selectedSession = action.payload;
            })
            .addCase(fetchSessionById.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.error.message;
            })
            .addCase(createSession.pending, (state) => {
                state.registerstatus = 'loading';
            })
            .addCase(createSession.fulfilled, (state, action) => {
                state.registerstatus = 'succeeded';
                //state.sessionList.push(action.payload);
            })
            .addCase(createSession.rejected, (state, action) => {
                state.registerstatus = 'failed';
                state.error = action.error.message;
            })
            .addCase(deleteSessionById.pending, (state) => {
                    state.deletestatus = 'loading';
                })
            .addCase(deleteSessionById.fulfilled, (state, action) => {
                    state.deletestatus = 'succeeded';
                  //  state.sessionList = state.sessionList.filter(session => session.id !== action.payload.id);
                })
            .addCase(deleteSessionById.rejected, (state, action) => {
                    state.deletestatus = 'failed';
                    state.error = action.error.message;
                })
                .addCase(fetchSessionByVisitorRelID.pending, (state) => {
                    state.status = 'loading';
                })
                .addCase(fetchSessionByVisitorRelID.fulfilled, (state, action) => {
                    state.status = 'succeeded';
                    state.selectedSession = action.payload;
                })
                .addCase(fetchSessionByVisitorRelID.rejected, (state, action) => {
                    state.status = 'failed';
                    state.error = action.error.message;
                })
    }
})

export default sessionSlice.reducer;